import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'autocompleteHighlightPipe' })
export class AutocompleteHighlightPipe implements PipeTransform {
  transform(suggestionTerm: string, searchTerm: string | null) {
    const lowerCaseSearchTerm = searchTerm?.trim().toLowerCase();

    if (lowerCaseSearchTerm && suggestionTerm.toLowerCase().startsWith(lowerCaseSearchTerm)) {
      const strongText = suggestionTerm.substring(lowerCaseSearchTerm.length);
      const strongElement = `<strong>${strongText}</strong>`;
      return lowerCaseSearchTerm + this.sanitizer.sanitize(SecurityContext.HTML, strongElement);
    }

    const strongElement = `<strong>${suggestionTerm}</strong>`;
    return this.sanitizer.sanitize(SecurityContext.HTML, strongElement);
  }

  constructor(private sanitizer: DomSanitizer) {}
}
